/* eslint-disable no-underscore-dangle */
import _ from 'lodash';
import classNames from 'classnames';

export const globalKey = 'rs-';
export const getClassNamePrefix = () => {
  return globalKey;
};
export const defaultClassPrefix = (name) => `${getClassNamePrefix()}${name}`;

export function prefix(pre, className) {
  if (!pre || !className) {
    return '';
  }

  if (_.isArray(className)) {
    return classNames(
      className.filter((name) => !!name).map((name) => `${pre}-${name}`)
    );
  }

  return `${pre}-${className}`;
}

export default _.curry(prefix);
